/**
 * What is the name of the secure https cookie we should be looking for
 * which holds our auth token?
 */
export const SECURE_AUTH_COOKIE_TOKEN = '__Secure-next-auth.session-token'

/**
 * What is the name of the insecure http cookie we should be looking for
 * which holds our auth token?
 */
export const AUTH_COOKIE_TOKEN = 'next-auth.session-token'

/**
 * Nextjs' LOCALE cookie
 * https://nextjs.org/docs/pages/building-your-application/routing/internationalization#leveraging-the-next_locale-cookie
 */
export const NEXT_LOCALE_COOKIE = 'NEXT_LOCALE'
export const NEXT_LOCALE_MAX_AGE = 60 * 60 * 24 * 7 // DECIDE

// The maximum age of the NextAuth.js issued JWT in seconds
// https://github.com/nextauthjs/next-auth/blob/main/packages/next-auth/src/jwt/types.ts#L44
export const NEXT_AUTH_JWT_MAX_AGE = 60 * 60 * 24 * 7 // 7 days

/**
 * Parse a jwt without Buffer given we need to work in edge-runtime
 *
 * @see https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
 * @see https://nextjs.org/docs/api-reference/edge-runtime
 */
const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const payload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(payload)
}

/**
 * Decode data from a signed, unencrypted token
 *
 * @note this does not verify the integrity of a token but it
 * is acceptable to do so on the frontend as any backend request
 * will be verified and we can reject any intercepted data then
 */
export const decodeUnverifiedToken = (token?: string) => {
  if (!token) {
    return null
  }

  try {
    const data = parseJwt(token)

    // if expired, token wont be valid
    if (data.exp * 1000 <= new Date().getTime()) {
      return null
    }

    return data
  } catch {
    // eslint-disable-next-line no-console
    console.warn('malformed token provided', token)

    // avoid crashing requests on the edge and instead just transparently
    // act like we have no auth - meaning a user would need to re-authenticate
    return null
  }
}

const permittedDestinations = [
  'https://www.gaiafamily.com/',
  'https://preview.gaiafamily.com/',
  'http://localhost:3000/',
]

// todo - this should work with only relative paths but current redirects generate absolute paths
export const isPermittedDestination = (destination: string) => {
  return (
    destination.startsWith(permittedDestinations[0]) ||
    destination.startsWith(permittedDestinations[1]) ||
    destination.startsWith(permittedDestinations[2]) ||
    destination.startsWith('/')
  )
}
